import { Location } from '@core/Router/locations';
import { lazy } from 'react';

const ServicesPageContainer = lazy(() =>
    import(/* webpackChunkName: "services" */ '@modules/services/ui/ServicesPage').then(m => ({
        default: m.ServicesPage,
    })),
);
const ServiceGroupPage = lazy(() =>
    import(/* webpackChunkName: "services" */ '@services/ui/ServiceGroupPage').then(m => ({
        default: m.ServiceGroupPage,
    })),
);

export const serviceLocations: Location[] = [
    {
        url: '/services',
        Component: ServicesPageContainer,
    },
    {
        url: '/services/service-group/:serviceGroupId',
        Component: ServiceGroupPage,
    },
];
